document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const thumbnail = event.target.closest('[data-gallery-thumb]');
  if (thumbnail) {
    const gallery = thumbnail.closest('[data-product-gallery]');
    const mainImage = gallery && gallery.querySelector('.product-gallery-main img');
    if (mainImage) {
      mainImage.src = thumbnail.dataset.imageSrc;
      mainImage.srcset = '';
      mainImage.alt = thumbnail.dataset.imageAlt || '';
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumbnail));
    }
    return;
  }
  const quantityButton = event.target.closest('[data-quantity-change]');
  if (quantityButton) {
    const input = quantityButton.parentElement.querySelector('input[name="quantity"]');
    if (input) { input.value = Math.max(1, (Number(input.value) || 1) + Number(quantityButton.dataset.quantityChange)); input.dispatchEvent(new Event('input', { bubbles: true })); }
    return;
  }
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const nav = document.querySelector('[data-mobile-nav]');
  if (!nav) return;
  const open = nav.hasAttribute('hidden');
  nav.toggleAttribute('hidden');
  toggle.setAttribute('aria-expanded', String(open));
});

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-extra-logo-option]')) {
    const panel = event.target.closest('[data-extra-logo]');
    if (event.target.checked) {
      const group = event.target.value.toLowerCase().includes('back') ? 'back' : '';
      if (group) {
        panel.querySelectorAll('[data-extra-logo-option]').forEach((input) => {
          if (input !== event.target && input.value.toLowerCase().includes(group)) input.checked = false;
        });
      }
    }
    const selected = [...panel.querySelectorAll('[data-extra-logo-option]:checked')].map((input) => input.value);
    const summary = panel.querySelector('[data-extra-logo-summary]');
    if (summary) summary.textContent = selected.length ? `Selected: ${selected.join(', ')}` : 'No extra logo selected';
  }
  if (!event.target.matches('[data-variant-select]')) return;
  const option = event.target.selectedOptions[0];
  const form = event.target.closest('form');
  const buttons = form ? form.querySelectorAll('[type="submit"]') : [];
  const price = document.querySelector('[data-product-price]');
  const comparePrice = document.querySelector('[data-compare-price]');
  const status = document.querySelector('[data-product-status]');
  buttons.forEach((button) => {
    button.disabled = option.dataset.available !== 'true';
    if (button.hasAttribute('data-add-cart')) button.textContent = option.dataset.available === 'true' ? 'Add to basket' : 'Sold out';
    if (button.hasAttribute('data-buy-now')) button.textContent = option.dataset.available === 'true' ? 'Buy now' : 'Unavailable';
  });
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (comparePrice) {
    comparePrice.textContent = option.dataset.comparePrice || '';
    comparePrice.hidden = !option.dataset.comparePrice;
  }
  if (status) {
    const available = option.dataset.available === 'true';
    status.classList.toggle('is-sold-out', !available);
    status.lastChild.textContent = available ? 'In stock and ready to brand' : 'Currently unavailable';
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.product-form');
  if (!form) return;
  if (form.dataset.submitting === 'true') { event.preventDefault(); return; }
  const panel = form.querySelector('[data-extra-logo]');
  const selectedLogos = panel ? [...panel.querySelectorAll('[data-extra-logo-option]:checked')] : [];
  const buyNow = event.submitter && event.submitter.hasAttribute('data-buy-now');
  if (selectedLogos.length === 0 && !buyNow) return;

  event.preventDefault();
  const button = event.submitter || form.querySelector('[type="submit"]');
  const formData = new FormData(form);
  const garmentVariantId = Number(formData.get('id'));
  const quantity = Math.max(1, Number(formData.get('quantity')) || 1);
  const placements = selectedLogos.map((input) => input.value);
  const originalLabel = button.textContent;
  const errorBox = form.querySelector('[data-product-error]');
  if (errorBox) errorBox.hidden = true;
  form.dataset.submitting = 'true';
  form.setAttribute('aria-busy', 'true');
  const group = selectedLogos.length ? (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`) : '';
  const controls = [...form.querySelectorAll('button, input, select')];
  const disabledBefore = controls.map((control) => control.disabled);
  controls.forEach((control) => { control.disabled = true; });
  form.classList.add('is-loading');
  button.textContent = selectedLogos.length ? 'Adding garment and logos…' : 'Taking you to checkout…';

  const items = [{
    id: garmentVariantId,
    quantity,
    properties: placements.length ? { 'Extra logo positions': placements.join(', '), '_logo_group': group, '_logo_role': 'garment' } : {}
  }];
  selectedLogos.forEach((input) => {
    items.push({
      id: Number(input.dataset.addonVariantId),
      quantity,
      properties: { '_logo_group': group, '_logo_role': 'logo', 'Logo application': input.value, 'For garment': document.querySelector('.product-info h1')?.textContent.trim() || 'Workwear' }
    });
  });

  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!response.ok) throw new Error((await response.json()).description || 'Could not add the items.');
    window.location.href = buyNow ? `${window.Shopify?.routes?.root || '/'}checkout` : `${window.Shopify?.routes?.root || '/'}cart`;
  } catch (error) {
    form.classList.remove('is-loading');
    button.textContent = originalLabel;
    form.dataset.submitting = 'false';
    form.removeAttribute('aria-busy');
    controls.forEach((control, index) => { control.disabled = disabledBefore[index]; });
    if (errorBox) { errorBox.textContent = `${error.message || 'Could not complete the request.'} Please check your basket before trying again.`; errorBox.hidden = false; errorBox.focus(); }
  }
});

// Live estimate uses Shopify's displayed currency and actual variant prices.
function updateOrderEstimate(form) {
  if (!form) return;
  const selected = form.querySelector('[data-variant-select]')?.selectedOptions[0];
  const base = Number(selected?.dataset.priceCents ?? form.dataset.basePrice) || 0;
  const logos = [...form.querySelectorAll('[data-extra-logo-option]:checked')];
  const extras = logos.reduce((sum, input) => sum + Number(input.dataset.addonPrice || 0), 0);
  const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value) || 1);
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style: 'currency', currency: form.dataset.currency || 'GBP'}).format((base + extras) * quantity / 100);
  const total = form.querySelector('[data-order-total]');
  if (total) total.textContent = money;
  const estimate = form.querySelector('[data-order-estimate]');
  if (estimate) estimate.hidden = false;
  const page = form.closest('.product-info');
  const bar = page?.querySelector('[data-mobile-purchase]');
  if (bar) {
    bar.hidden = false;
    bar.querySelector('[data-mobile-total]').textContent = money;
    const button = bar.querySelector('[data-mobile-buy]');
    const available = selected ? selected.dataset.available === 'true' : !form.querySelector('[data-buy-now]').disabled;
    button.disabled = !available || form.dataset.submitting === 'true';
    button.textContent = available ? 'Buy now' : 'Sold out';
    document.body.classList.add('has-purchase-bar');
  }
}
document.querySelectorAll('.product-form').forEach(updateOrderEstimate);
document.addEventListener('input', (event) => updateOrderEstimate(event.target.closest('.product-form')));
document.addEventListener('change', (event) => updateOrderEstimate(event.target.closest('.product-form')));
document.addEventListener('click', (event) => {
  if (event.target.closest('[data-mobile-buy]')) {
    const form = event.target.closest('.product-info').querySelector('.product-form');
    if (form.dataset.submitting !== 'true') form.requestSubmit(form.querySelector('[data-buy-now]'));
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const nav = document.querySelector('[data-mobile-nav]');
  if (nav && !nav.hidden) { nav.hidden = true; const toggle = document.querySelector('[data-menu-toggle]'); toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
});
// Each garment and its paid logos keep the same quantity in the basket.
function syncLogoQuantities(form, source) {
  const line = source.closest('[data-cart-line]');
  if (!line?.dataset.group) return;
  const quantity = source.value;
  form.querySelectorAll('[data-cart-line]').forEach((row) => {
    if (row.dataset.group === line.dataset.group) row.querySelector('[data-cart-quantity]').value = quantity;
  });
}
document.addEventListener('input', (event) => {
  if (!event.target.matches('[data-cart-quantity]')) return;
  const form = event.target.closest('[data-cart-form]');
  syncLogoQuantities(form, event.target);
  form.querySelector('[data-cart-feedback]').hidden = false;
});
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-cart-remove]');
  const row = link?.closest('[data-cart-line]');
  if (!row?.dataset.group) return;
  // Remove a decorated garment as a complete group, avoiding orphan charges.
  event.preventDefault();
  const form = row.closest('[data-cart-form]');
  row.querySelector('[data-cart-quantity]').value = 0;
  syncLogoQuantities(form, row.querySelector('[data-cart-quantity]'));
  form.requestSubmit(form.querySelector('[name="update"]'));
});
